import { useState } from 'react';
import { Button } from '@usacow/ds';
import { DrillHost, DRILL_LABEL, type DrillKind } from '@usacow/drills';
import { api } from '../lib/api';

/** Sequences a list of drills with a progress bar; records each result. Used by the
 *  Daily Workout and Weakness Repair sessions. */
export function DrillSession({ slots, onDone }: { slots: DrillKind[]; onDone: () => void }) {
  const [i, setI] = useState(0);

  if (i >= slots.length) {
    return (
      <div className="dr-done">
        <div className="t-eyebrow">session complete</div>
        <p className="dr-done__p">Nice work. Your mastery and review schedule just updated.</p>
        <div className="dr-done__cta">
          <Button variant="primary" onClick={onDone}>
            Back to home
          </Button>
        </div>
      </div>
    );
  }

  const kind = slots[i]!;
  return (
    <div>
      <div className="sess-bar">
        {slots.map((_, j) => (
          <span
            key={j}
            className={`sess-bar__seg${j < i ? ' is-done' : j === i ? ' is-active' : ''}`}
          />
        ))}
      </div>
      <div className="sess-meta t-eyebrow">
        slot {i + 1} / {slots.length} · {DRILL_LABEL[kind]}
      </div>
      <DrillHost
        key={i}
        kind={kind}
        continueLabel={i < slots.length - 1 ? 'Next slot' : 'Finish'}
        onComplete={({ response }) => {
          void api.submitDrill(kind, response).catch(() => {});
          setI(i + 1);
        }}
      />
    </div>
  );
}
